import { CREATE_Certification, REMOVE_Certification } from "./actions";
import { loadFromLocalStorage, saveToLocalStorage } from "../../../../../utils/localStorage";

export const certification = (state=loadFromLocalStorage(CREATE_Certification, []), action) =>{
    const {type, payload} = action;

    switch(type){
        case CREATE_Certification:{
            const {certification} = payload;
            const newCertification = {
                certification,
            };
            const updatedState = state.concat(newCertification);
            saveToLocalStorage(CREATE_Certification, updatedState);
            return updatedState;
        }
        case REMOVE_Certification: {
            const {certification} = payload;
            const updatedState = state.filter(obj => obj.certification !== certification);
            saveToLocalStorage(CREATE_Certification, updatedState);
            return updatedState;
        }
        default: 
            return state;
    }
}